import { Base } from "../core/base.model";
import { Servidor } from "./servidor.model";


export class Aplicacion extends Base{
    id: number;
    idTipo: string;
    descripcion: string;
    version: string;
    id_Servidor: string;
    ipServidor: string;
    id_corporativo: number;
    listaAplicaciones: Aplicacion [];
}